import React from 'react';

const JOURS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
const MOMENT_SHORT = { 'Petit-déjeuner': 'PDJ', Midi: 'Midi', Sunset: 'Sunset', Soir: 'Soir' };

export const SemaineLieuxMoments = ({ semaine }) => {
  if (!semaine) return null;
  const byDay = JOURS.map((_, i) => semaine.shifts.filter(s => s.jour === i));
  const num = semaine.semaine.split('-W')[1];
  return (
    <section className="rounded-2xl border border-[var(--bord)] bg-[var(--carte)] p-4 space-y-3 no-poste-print" data-testid="employee-fiche-semaine">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div><p className="hp-kicker">Où et quand</p><h4>Semaine {num}</h4></div>
        <span className="kit-chip fh-chip" data-testid="employee-fiche-semaine-heures">{semaine.shifts.length ? `${semaine.heures} h planifiées · ${semaine.shifts.length} horaire${semaine.shifts.length > 1 ? 's' : ''}` : '0 h planifiée · 0 horaire'}</span>
      </div>
      {semaine.resume.length === 0 ? (
        <p className="text-sm text-[var(--texte-2)]" data-testid="employee-fiche-semaine-vide">{semaine.shifts.length ? `${semaine.shifts.length} horaire${semaine.shifts.length > 1 ? 's' : ''} planifié${semaine.shifts.length > 1 ? 's' : ''} sans lieu ni moment renseigné — précisez-les dans le Planning pour les voir ici.` : 'Aucun horaire planifié cette semaine — ajoutez-le dans le Planning pour voir ici son lieu et ses moments de service.'}</p>
      ) : (
        <>
          <div className="fh-chips" data-testid="employee-fiche-semaine-resume">
            {semaine.resume.map(r => (
              <span key={r.lieu_id} className="kit-chip fh-chip" data-testid={`employee-fiche-lieu-${r.lieu_id}`}>
                <i className="fh-dot" style={{ background: r.color }} />{r.name} · {r.moments.join(' + ') || '—'} · {r.heures} h
              </span>
            ))}
          </div>
          <div className="overflow-x-auto -mx-1 px-1">
            <table className="w-full text-xs border-separate border-spacing-1" data-testid="employee-fiche-semaine-table">
              <thead>
                <tr>{JOURS.map((j, i) => <th key={j} className={`text-xs uppercase tracking-wider font-extrabold pb-0.5 ${byDay[i].length ? 'text-[var(--texte)]' : 'text-neutral-300'}`}>{j}</th>)}</tr>
              </thead>
              <tbody>
                <tr>
                  {byDay.map((list, i) => (
                    <td key={i} className="align-top" data-testid={`employee-fiche-jour-${i}`}>
                      {list.length === 0 ? <div className="fiche-day-empty h-14 flex items-center justify-center text-xs">repos</div> : list.map((s, k) => (
                        <div key={k} className="fiche-day-cell p-1.5 mb-1 min-w-[64px]">
                          <p className="fiche-day-hours flex items-center gap-1 leading-tight"><i className="pl-shift-dot" style={{ background: s.lieux[0]?.color || '#6B7280', marginRight: 0 }} />{s.heure_debut}</p>
                          <p className="fiche-day-hours leading-tight pl-[11px]">{s.heure_fin}</p>
                          <p className="text-xs font-semibold text-[var(--texte-2)] leading-tight mt-0.5 pl-[11px]">{s.moments.map(m => MOMENT_SHORT[m] || m).join(' · ') || '—'}</p>
                          {s.lieux.length > 1 && <div className="flex gap-0.5 mt-1 pl-[11px]">{s.lieux.map(l => <span key={l.lieu_id} title={l.name} className="w-2 h-2 rounded-[3px]" style={{ background: l.color }} />)}</div>}
                        </div>
                      ))}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </section>
  );
};
